import { DM_Serif_Display, Source_Sans_3 } from 'next/font/google';

const dmSerifDisplay = DM_Serif_Display({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-dm-serif-display',
  weight: ['400'],
});

const sourceSansPro = Source_Sans_3({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-source-sans-pro',
  weight: ['400', '500', '600', '700'],
});

export const supportedFonts = [dmSerifDisplay, sourceSansPro];
